import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateComponentOpaque } from '../../redux/component_opaque/component_actions';

const mapStateToProps = state => ({
  isDuplicating: state.component.opaque.isDuplicating,
  errorMessage: state.component.opaque.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateComponentOpaque(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/OpaqueComponentDuplicateModal.js